module.exports = __webpack_public_path__ + "static/img/p_06.6ff9ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_06.png
// module id = ipf6
// module chunks = 9